import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MentoratService } from '../../services/mentorat.service';
import { AppelsService } from 'src/app/modules/appels/service/appels.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { ActivatedRoute, Router } from '@angular/router';

export interface CandidatMentor {
  id: number;
  iuf: string;
  firstname: string;
  lastname: string;
  dateBirth: Date;
  gender: string;
  email: string;
  phoneNumber: string;
  nationality: string;
  region: string;
  city: string;
  currentStatus: string[];
  highDiplome: string;
  onlineAcademyExprience: boolean;
  mailSent: boolean;
  confirmation: boolean;
  mentoratsExprience: boolean;
  descOnlineAcademyExprience: string;
  descMentoratsExprience: string;
  additionalInformation: string;
  age: number;
  createdAt: string;
  updatedAt: string;
  cohorte: string;
  certificats: CertificatMentor[];
}

export interface CertificatMentor {
  id: number;
  name: string;
  certificateCode: string;
  shortname: string;
  fullname: string;
  plateforme: string;
  cohorte: string;
  status: string;
}

@Component({
  selector: 'app-list-mentors',
  templateUrl: './list-mentors.component.html',
  styleUrls: ['./list-mentors.component.css'],
})
export class ListMentorsComponent {
  certificateOption: any[] = [];
  selectedCertificateId: number = -1;
  allCandidats: CandidatMentor[] = [];
  filteredCandidats: CandidatMentor[] = [];
  currentFilter: 'all' | 'en-cours' | 'retenus' | 'rejetes' = 'all';

  displayedColumns: string[] = [
    'name',
    'email',
    'gender',
    'nombrecertificats',
    'certificatsRetenus',
    'deliberatedBy',
    'action',
  ];

  dataSource = new MatTableDataSource<CandidatMentor>();
  pageSize: number = 10;
  pageSizeOptions: number[] = [10, 20, 30, 50, 100];

  showConfirmationModal: boolean = false;
  ligneDetails: any;
  showSpinner = false;
  popupVisible: boolean = false;
  isNotifying: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  activeAll: boolean = true;
  activeEnCours: boolean = false;
  activeRetenus: boolean = false;
  activeRejetes: boolean = false;

  succesSingle: boolean = false;
  errorSingle: boolean = false;
  messageSingle: string = '';

  @ViewChild('paginatorDetails') paginatorDetails!: MatPaginator;
  dataSourceDetails = new MatTableDataSource<any>([]);
  certificatsPagines: any[] = [];
  private lastPageIndex = -1;
  private lastPageSize = -1;
  private lastCertificatsLength = -1;

  user: any | null;
  roles!: any;
  isResponsableCertificatFCC: boolean = false;
  responsableIuf: any;

  constructor(
    private utilisateurService: MentoratService,
    public spinnerService: SpinnerServiceService,
    private router: Router, private activateRoute: ActivatedRoute
  ) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngOnInit(): void {
    this.user = sessionStorage.getItem('user');
    this.roles = JSON.parse(this.user)?.roles;
    if (this.roles) {
      if (this.roles?.length != 0) {
        this.roles.forEach((element: { id: number; roleName: any }) => {
          switch (element.roleName) {
            case 'responsable-certificat': {
              this.isResponsableCertificatFCC = true;
              break;
            }
          }
        });
      }
    }
    this.responsableIuf = JSON.parse(this.user)?.iuf;
    this.loadCandidatsMentors();
    this.loadCertificatesMentorat();
    this.activateRoute.queryParams.subscribe(params => {
      const shouldOpen = params['openModal'] === 'true';
      const idToFind = params['candidatId'];
      const cachedCandidat = localStorage.getItem('last_evaluated_candidat');
      if (shouldOpen && idToFind) {
        const rowToOpen = JSON.parse(cachedCandidat as any);
        if (rowToOpen) {
          this.togglePopup(rowToOpen);
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSourceDetails.paginator = this.paginatorDetails;
  }
  loadCandidatsMentors(): void {
    this.spinnerService.showSpinner();

    let request$;

    if (this.isResponsableCertificatFCC) {
      request$ = this.utilisateurService.getCandidatsByResponsable(this.responsableIuf);
    } else {
      request$ = this.utilisateurService.getAllCandidatsMentors();
    }

    request$.subscribe({
      next: (response: CandidatMentor[]) => {
        this.allCandidats = response;
        this.filteredCandidats = [...this.allCandidats];
        this.updateDataSource();
        this.spinnerService.hideSpinner();
      },
      error: (error) => {
        console.error('Erreur lors du chargement des candidats:', error);
        this.spinnerService.hideSpinner();
      },
    });
  }

  loadCertificatesMentorat(): void {
    let request$;
    if (this.isResponsableCertificatFCC) {
      request$ = this.utilisateurService.getCertificatesByResponsable(this.responsableIuf);
    } else {
      request$ = this.utilisateurService.getAllCertificateMentors();
    }
    request$.subscribe({
      next: (response) => {
        this.certificateOption = response;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des certificats:', error);
      },
    });
  }

  updateDataSource(): void {
    this.dataSource = new MatTableDataSource<CandidatMentor>(
      this.filteredCandidats,
    );
    this.dataSource.paginator = this.paginator;

    // Filtre personnalisé pour la recherche
    this.dataSource.filterPredicate = (
      data: CandidatMentor,
      filter: string,
    ) => {
      const searchStr = filter.toLowerCase();
      return (
        data.firstname?.toLowerCase().includes(searchStr) ||
        data.lastname?.toLowerCase().includes(searchStr) ||
        data.email?.toLowerCase().includes(searchStr) ||
        data.gender?.toLowerCase().includes(searchStr) ||
        data.city?.toLowerCase().includes(searchStr)
      );
    };
  }

  applyFilterSearch(event: Event): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    this.dataSource.filter = filter;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilterAll(): void {
    this.filteredCandidats = [...this.allCandidats];
    this.updateDataSource();
    this.resetActiveButtons();
    this.activeAll = true;
    this.selectedCertificateId = -1;
    this.currentFilter = 'all';
  }

  applyFilterEnCours(): void {
    this.filteredCandidats = this.allCandidats.filter((candidat) =>
      candidat.certificats.some(
        (cert) =>
          cert.status?.toLowerCase() === 'en cours' ||
          cert.status === 'En cours de traitement',
      ),
    );
    this.updateDataSource();
    this.resetActiveButtons();
    this.activeEnCours = true;
    this.currentFilter = 'en-cours';
  }

  applyFilterRetenus(): void {
    this.filteredCandidats = this.allCandidats.filter((candidat) =>
      candidat.certificats.some(
        (cert) => cert.status?.toLowerCase() === 'retenu',
      ),
    );
    this.updateDataSource();
    this.resetActiveButtons();
    this.activeRetenus = true;
    this.currentFilter = 'retenus';
  }

  applyFilterRejetes(): void {
    this.filteredCandidats = this.allCandidats.filter((candidat) =>
      candidat.certificats.some(
        (cert) =>
          cert.status?.toLowerCase() === 'rejeté' ||
          cert.status?.toLowerCase() === 'rejete',
      ),
    );
    this.updateDataSource();
    this.resetActiveButtons();
    this.activeRejetes = true;
    this.currentFilter = 'rejetes';
  }

  onCertificateSelectionChange(): void {
    const certificateId = Number(this.selectedCertificateId);
    if (certificateId === 0) {
      this.applyFilterAll();
    } else if (certificateId > 0) {
      this.filteredCandidats = this.allCandidats.filter((candidat) =>
        candidat.certificats.some((cert) => cert.id === certificateId),
      );
      this.updateDataSource();
      this.resetActiveButtons();
    }
  }

  get displayedColumnsFiltered(): string[] {
    if (this.currentFilter === 'all') {
      return ['name', 'email', 'gender', 'nombrecertificats', 'deliberatedBy', 'action'];
    }
    return this.displayedColumns;
  }

  // obtenir le label de la colonne & afficher dynamiquement
  getColumnLabel(): string {
    switch (this.currentFilter) {
      case 'en-cours':
        return 'N.en cours';
      case 'retenus':
        return 'N.retenus';
      case 'rejetes':
        return 'N.rejetés';
      default:
        return '';
    }
  }

  // obtenir le nombre de certificats selon le filtre
  getNombreCertificatsFiltre(candidat: CandidatMentor): number {
    if (!candidat.certificats || candidat.certificats.length === 0) {
      return 0;
    }

    switch (this.currentFilter) {
      case 'en-cours':
        return candidat.certificats.filter(
          (cert) =>
            cert.status?.toLowerCase() === 'en cours' ||
            cert.status === 'En cours de traitement',
        ).length;
      case 'retenus':
        return candidat.certificats.filter(
          (cert) => cert.status?.toLowerCase() === 'retenu',
        ).length;
      case 'rejetes':
        return candidat.certificats.filter(
          (cert) =>
            cert.status?.toLowerCase() === 'rejeté' ||
            cert.status?.toLowerCase() === 'rejete',
        ).length;
      default:
        return 0;
    }
  }

  resetActiveButtons(): void {
    this.activeAll = false;
    this.activeEnCours = false;
    this.activeRetenus = false;
    this.activeRejetes = false;
  }

  togglePopup(row: CandidatMentor): void {
    this.ligneDetails = row;
    this.popupVisible = true;
    this.dataSourceDetails.data = row.certificats || [];
    if (this.paginatorDetails) {
      this.paginatorDetails.firstPage();
    }
  }

  closeModalDetails(): void {
    this.popupVisible = false;
  }

  delibererCandidats(): void {
    if (this.isNotifying) {
      return;
    }
    if (!this.ligneDetails) {
      alert('Aucun candidat sélectionné');
      return;
    }
    this.showConfirmationModal = true;
  }

  confirmDeliberation(): void {
    this.showConfirmationModal = false;
    this.isNotifying = true;
    this.spinnerService.showSpinner();

    // Envoi de l'email pour le candidat sélectionné
    this.utilisateurService
      .notifierDeliberationCandidatureMentorat(this.ligneDetails.iuf)
      .subscribe({
        next: (response) => {
          console.log(
            `Email envoyé à ${this.ligneDetails.email}, IUF: ${this.ligneDetails.iuf}`,
          );
          this.spinnerService.hideSpinner();
          this.isNotifying = false;

          // snackbar de succès
          this.messageSingle =
            'Notification de délibérationenvoyée avec succès';
          this.succesSingle = true;
          setTimeout(() => {
            this.succesSingle = false;
            this.messageSingle = '';
            this.closeModalDetails();
          }, 3500);
        },
        error: (error) => {
          console.error(
            `Erreur pour ${this.ligneDetails.email}, IUF: ${this.ligneDetails.iuf}:`,
            error,
          );
          this.spinnerService.hideSpinner();
          this.isNotifying = false;

          // snackbar d'erreur
          this.messageSingle =
            error.message ||
            "Erreur lors de l'envoi de la notification de délibération";
          this.errorSingle = true;
          setTimeout(() => {
            this.errorSingle = false;
            this.messageSingle = '';
          }, 3500);
        },
      });
  }

  cancelDeliberation(): void {
    this.showConfirmationModal = false;
  }

  voirDossier(candidat: CandidatMentor, certificat: CertificatMentor): void {
    localStorage.setItem('last_evaluated_candidat', JSON.stringify(candidat));
    this.router.navigate(
      [
        '/dashboard/mentorat/candidats/dossiers',
        candidat.id,
        certificat.cohorte,
      ],
      {
        queryParams: {
          candidatId: candidat.id,
          candidatIUF: candidat.iuf,
          certificatId: certificat.id,
          candidatName: `${candidat.firstname} ${candidat.lastname}`,
          cohorte: certificat.cohorte,
          currentStatus: certificat.status,
          status: certificat.status,
          selectedStatus: certificat.status,
        },
      },
    );
    this.closeModalDetails();
  }
  ngDoCheck() {
    const currentLength = this.ligneDetails?.certificats?.length || 0;
    const currentPage = this.paginatorDetails?.pageIndex || 0;
    const currentSize = this.paginatorDetails?.pageSize || 0;
    if (
      currentPage !== this.lastPageIndex ||
      currentSize !== this.lastPageSize ||
      currentLength !== this.lastCertificatsLength
    ) {
      this.updatePagination();
      this.lastPageIndex = currentPage;
      this.lastPageSize = currentSize;
      this.lastCertificatsLength = currentLength;
    }
  }

  private updatePagination() {
    if (!this.ligneDetails?.certificats || !this.paginatorDetails) {
      this.certificatsPagines = this.ligneDetails?.certificats || [];
      return;
    }
    const start = this.paginatorDetails.pageIndex * this.paginatorDetails.pageSize;
    const end = start + this.paginatorDetails.pageSize;
    this.certificatsPagines = this.ligneDetails.certificats.slice(start, end);
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'MENTORAT' },
    { label: 'CANDIDATS MENTORS', url: '/dashboard/users/list-mentors' },
  ];
}
